module.exports = __webpack_public_path__ + "static/img/body0.f20189b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/onboarding/views/invite/images/animation/body0.png
// module id = pThH
// module chunks = 12